import React from 'react'

import ExpenseList from './ExpenseList'
import ExpenseListView from './ExpenseListView'
// import ExpenseChart from './ExpenseChart'

export default function Dashboard() {
  return (
    <>
        <ExpenseList />
        <ExpenseListView />
        {/* <ExpenseChart /> */}
    </>
  )
}
